"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPersonName = void 0;
var format_template_1 = require("./format-template");
var has_all_template_params_1 = require("./has-all-template-params");
/**
 * Formats given, middle, and family names as a string.
 *
 * @hidden
 * @param personName The given, middle, and family names.
 * @param options The template format options to be used.
 * @returns The formatted string.
 */
var formatPersonName = function (personName, options) {
    var params = __assign(__assign({}, personName), { givenInitial: personName.givenName ? personName.givenName.slice(0, 1) : undefined, middleInitial: personName.middleName ? personName.middleName.slice(0, 1) : undefined, familyInitial: personName.familyName ? personName.familyName.slice(0, 1) : undefined });
    var template = options.personName.formats.find(function (format) { return has_all_template_params_1.hasAllTemplateParams(format, params); });
    if (!template)
        return;
    return format_template_1.formatTemplate(template, params, options);
};
exports.formatPersonName = formatPersonName;
//# sourceMappingURL=format-person-name.js.map